import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { Modal, Button } from 'react-bootstrap'
import { blockUserById, isUserBlockedById, unblockUserById } from '../../services/users'
import Loading from '../Loading'
import { checkIfUserIsBlocked } from '../../helpers/Users'
const BlockUserModal = ({ isOpen, onClose, userId }) => {
  const [blockDate, setBlockDate] = useState(new Date(new Date().setMonth(new Date().getMonth() + 1)))
  const [blockFromDate, setBlockFromDate] = useState(new Date())
  const [blockedObj, setBlockedObj] = useState({})
  const [reason, setReason] = useState('')
  const [blocked, setBlocked] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleBlock = () => {
    setIsLoading(true)
    blockUserById(userId, { blockedUntil: blockDate, reason, createdAt: blockFromDate }).then(() => {
      window.location = `/usuario/${userId}`
    })
  }

  const handleUnblock = () => {
    setIsLoading(true)
    unblockUserById(userId).then(() => {
      window.location = `/usuario/${userId}`
    })
  }

  useEffect(() => {
    if (userId && userId !== '') {
      isUserBlockedById(userId).then((data) => {
        console.log('Diego')
        console.log(data)
        if (data.reason) {
          setBlocked(true)
          setBlockedObj(data)
        } else {
          setBlocked(false)
        }
      })
    }
  }, [userId])

  function isBlockValid() {
    return blockDate && reason
  }
  return (
    <Modal show={isOpen} onHide={() => onClose(false)} dialogClassName="modal-dialog-centered modal-sm">
      <Modal.Header closeButton>
        <Modal.Title>Bloqueio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {blocked ? (
          <div>
            <p>Foi bloqueado em {new Date(blockedObj.createdAt).toLocaleString('pt-BR')}</p>

            <p>Motivo</p>
            <p>E ficara bloqueado até {new Date(blockedObj.blockedUntil).toLocaleString('pt-BR')}</p>
            <p className="alert alert-warning">{blockedObj.reason}</p>
          </div>
        ) : (
          <div>
            <p>
              <label>Motivo</label>
              <input
                type="text"
                className="form form-control my-2 p-2"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </p>
            <p>
              <label>De</label>
              <p>
                <DatePicker
                  selected={blockFromDate}
                  className="form form-control my-2 p-2"
                  onChange={(date) => setBlockFromDate(date)}
                />
              </p>
            </p>
            <p>
              <label>Até</label>
              <p>
                <DatePicker
                  selected={blockDate}
                  className="form form-control my-2 p-2"
                  onChange={(date) => setBlockDate(date)}
                />
              </p>
            </p>
          </div>
        )}
        {isLoading && (
          <p>
            <Loading size={60} />
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        {blocked ? (
          <Button variant="warning" onClick={handleUnblock} disabled={isLoading}>
            Desbloquear
          </Button>
        ) : (
          <Button variant="danger" onClick={handleBlock} disabled={!isBlockValid() || isLoading}>
            Bloquear
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default BlockUserModal
